// WO-35 (founder): two kinds instead of Bug + Issue: "Bug / issue" (stored as 'bug'; older rows may say 'issue') and
// "Feature request" (stored as 'feature'). Copy follows the kind.
export const FEEDBACK_KINDS = {
  bug: {
    tab: 'Bug / issue',
    title: 'Report a problem',
    subtitle: 'Tell us what went wrong. We include the page you are on.',
    label: 'What went wrong?',
    placeholder: 'e.g. The price chart on this card is empty.',
    empty: 'Please tell us briefly what went wrong.',
    thanks: 'Thanks! We got your report.',
  },
  feature: {
    tab: 'Feature request',
    title: 'Suggest a feature',
    subtitle: 'Tell us what would make Lilycove better for you.',
    label: 'What would you like to see?',
    placeholder: 'e.g. Show which printing each search result is.',
    empty: 'Please describe the feature you would like.',
    thanks: 'Thanks! We got your idea.',
  },
};

